export default __webpack_public_path__ + "static/event_galerie_2023-b5d281dbb21c1aa1e4b7077c7829e7fb.mp4";